import { FormField, TextArea } from "@repo/skapa";
import { useSetDebounceValue } from "@repo/ui";
import { useState } from "react";

interface TextAreaFieldProps {
  id: string;
  label: string;
  value?: string;
  editable?: boolean;
  onChange?: (newValue?: string) => void;
  maxLength?: number;
}
export const TextAreaField = ({
  id,
  label,
  value,
  editable,
  onChange,
  maxLength,
}: TextAreaFieldProps) => {
  const saveValue = (newValue?: string) => {
    if (value !== newValue) {
      onChange?.(newValue);
    }
  };
  const [textValue, setTextValue] = useState(value);
  const { setValueDebounced, clearDebounce } = useSetDebounceValue(
    saveValue,
    2500
  );

  return (
    <FormField>
      <TextArea
        id={id}
        label={label}
        disabled={editable === false}
        value={textValue ?? ""}
        maxLength={maxLength}
        onChange={(e) => {
          setTextValue(e.target.value);
          setValueDebounced(e.target.value);
        }}
        onBlur={() => {
          clearDebounce();
          saveValue(textValue);
        }}
      />
    </FormField>
  );
};
